import { Component, Input } from '@angular/core';

import { LoadablePageResource } from './page-resource';

@Component({
  selector: 'rl-page-content',
  templateUrl: './page-content.component.html',
})
export class PageContentComponent {
  @Input() pageContent: LoadablePageResource;
}
